var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('heading',{attrs:{"h1":_vm.user.clientName}},[(!_vm.user.isLoggedIn)?_c('Login'):_vm._e(),(_vm.user.isLoggedIn)?_c('LoggedIn'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }